import * as yup from 'yup';

import { SUPPORTED_FORMATS, ATTACHMENT_MAX_FILE_NAME_LENGTH } from '../../../config';
import startupConfig from '../../../config/startupConfig';

export const validateFilesLength = (value, isIndividual) => {
  const maxFilesCount = startupConfig.get().trustDeedAttachment.maxFilesCount;
  let error;
  if ((value && value.length) > maxFilesCount) {
    error = `A maximum of ${maxFilesCount} files is allowed`;
  }
  if (isIndividual === 'true' && (!value || value.length < 1)) {
    error = 'Please upload at least one trust deed';
  }
  return error;
};

export const trusteeSchema = (props) => {
  const {
    trustDeedAttachmentConfig: { maxFileSizeInMb },
  } = props;
  const maxFileSize = maxFileSizeInMb * 1048576;

  return yup.object().shape({
    isIndividual: yup.string(),
    trusteeNames: yup
      .array()
      .of(
        yup.object().shape({
          firstName: yup.string(),
          lastName: yup.string(),
        }),
      )
      .when('isIndividual', {
        is: (val) => val === 'true',
        then: yup
          .array()
          .of(
            yup.object().shape({
              firstName: yup
                .string()
                .max(40, 'Please enter no more than 40 characters')
                .required('Please enter a first name'),
              lastName: yup
                .string()
                .max(80, 'Please enter no more than 80 characters')
                .required('Please enter a last name'),
            }),
          )
          .required(),
      }),
    files: yup
      .array()
      .of(
        yup
          .mixed()
          .test('maxFileSize', `The maximum file size allowed is ${maxFileSizeInMb}MB`, (value) => {
            const isValid = value && value.size <= maxFileSize;
            return isValid;
          })
          .test('minFileSize', 'The file must not be empty', (value) => {
            const isValid = value && value.size > 0;
            return isValid;
          })
          .test(
            'fileFormat',
            `The supported file types are ${SUPPORTED_FORMATS.toString()}`,
            (value) => value && SUPPORTED_FORMATS.includes(value.type),
          )
          .test(
            'fileName',
            `The maximum length of a file name is ${ATTACHMENT_MAX_FILE_NAME_LENGTH} characters`,
            (value) => value.name.length <= ATTACHMENT_MAX_FILE_NAME_LENGTH,
          ),
      )
      .test({
        name: 'files-length',
        // eslint-disable-next-line object-shorthand, func-names
        test: function (value) {
          const isIndividual = this.resolve(yup.ref('isIndividual'));
          const errorMessage = validateFilesLength(value, isIndividual);
          return !errorMessage;
        },
      }),
  });
};
